import * as React from "react";
function MovieSvg({ width}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      viewBox="0 0 1000 1000"
      fill="currentColor"
      className={`bi bi-heart-fill`}
    >
      <g>
        <path d="M847.9,517.1l-158.1-63.4V326.9l158.1-63.4c17.5,0,31.6,14.2,31.6,31.7v190.1C879.5,502.9,865.4,517.1,847.9,517.1z M547.4,295.2c-78.6,0-142.3-63.9-142.3-142.6C405.1,73.9,468.8,10,547.4,10s142.3,63.9,142.3,142.6C689.8,231.4,626,295.2,547.4,295.2z M262.8,295.2c-78.6,0-142.3-63.9-142.3-142.6C120.5,73.9,184.2,10,262.8,10c78.6,0,142.3,63.9,142.3,142.6C405.1,231.4,341.4,295.2,262.8,295.2z M658.1,295.2v285.2H481.6c-1.6,26.3-13.2,49-30.3,61.8h17.8l126.2,284.5h-31.4l-42.1-94.9h-84.1V990h-31.5V831.9h-85.5L278,926.8h-31.5l128.2-284.5h11.9c-17.1-12.8-28.6-35.5-30.3-61.8H152.1V295.2H658.1L658.1,295.2z M406.1,652.1c-1.3-0.3-2.5-1-3.8-1.4l-67.4,149.7h71.2V652.1z M437.7,649.8v150.5h70.1l-67.2-151.7C439.6,649.1,438.7,649.4,437.7,649.8z" />
      </g>
    </svg>
  );
}

export default MovieSvg;
